import {combineReducers} from '@modifi/redux'
import collectionReducer from './collection'
import createReducer from './create'

export default combineReducers({
  collection: collectionReducer,
  create: createReducer,
})
